/* EZCURB shared add-to-cart -> opens Dawn cart drawer, with safe fallbacks.
   Any <form class="ezc-cart-form"> posting to /cart/add is intercepted. */
(function () {
  function bind() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.classList || !form.classList.contains('ezc-cart-form')) return;

      var cart = document.querySelector('cart-drawer');
      // No drawer available -> let the browser submit normally (adds + goes to /cart).
      if (!cart || typeof cart.renderContents !== 'function') return;

      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var original = btn ? btn.innerHTML : '';
      if (btn) { btn.setAttribute('disabled', 'disabled'); btn.innerHTML = 'Adding...'; }

      var fd = new FormData(form);
      try {
        var ids = cart.getSectionsToRender().map(function (s) { return s.id; });
        fd.append('sections', ids.join(','));
        fd.append('sections_url', window.location.pathname);
      } catch (err) {}

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
        body: fd
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { // error (sold out, etc.)
            if (btn) { btn.innerHTML = res.message || 'Unavailable'; setTimeout(reset, 1700); }
            return;
          }
          try {
            cart.renderContents(res);
            document.dispatchEvent(new CustomEvent('ezc:cart:added'));
            var pill = document.getElementById('cart-icon-bubble') || document.querySelector('.header__icon--cart');
            if (pill) { pill.classList.add('ezc-cart-pulse'); setTimeout(function () { pill.classList.remove('ezc-cart-pulse'); }, 600); }
            if (btn) { btn.innerHTML = 'Added ✓'; setTimeout(reset, 1400); }
          } catch (err) { window.location = '/cart'; }
        })
        .catch(function () { if (btn) btn.removeAttribute('disabled'); form.submit(); });

      function reset() { if (btn) { btn.innerHTML = original; btn.removeAttribute('disabled'); } }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
})();

/* Safety net: keep the cart drawer's line items in sync with the real cart.
   Fixes a section-render edge case where the total updates on add but the new
   line item does not appear until a full page load. Runs only when there is an
   actual mismatch, so normal opens are untouched. */
(function () {
  function init() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var busy = false;

    function syncFromServer() {
      busy = true;
      // /cart/update.js with an empty update + sections renders the snippet-based
      // cart-drawer section reliably (the /?sections= query API cannot, because the
      // drawer is a snippet, not a placed section). Returns the freshly rendered HTML.
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: {}, sections: 'cart-drawer', sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var html = cart && cart.sections && cart.sections['cart-drawer'];
          var cur = document.getElementById('CartDrawer');
          if (!html || !cur) { busy = false; return; }
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer');
          if (fresh) {
            cur.innerHTML = fresh.innerHTML;
            drawer.classList.remove('is-empty');
            var di = cur.querySelector('.drawer__inner');
            if (di) di.classList.remove('is-empty');
            var ov = cur.querySelector('#CartDrawer-Overlay');
            if (ov) ov.addEventListener('click', function () { if (typeof drawer.close === 'function') drawer.close(); });
          }
          busy = false;
        })
        .catch(function () { busy = false; });
    }
    window.__ezcSyncDrawer = syncFromServer;

    function checkAndRepair() {
      if (busy) return;
      var shown = drawer.querySelectorAll('.cart-item').length;
      fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var lines = (cart.items || []).length;
          if (lines !== shown) syncFromServer();
        })
        .catch(function () {});
    }

    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].attributeName === 'class' && drawer.classList.contains('active')) {
          setTimeout(checkAndRepair, 60);
          break;
        }
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Free gift (Color Kit) auto-add. A product page sets
   window.ezcGiftKit = { kitId: <variant id>, qualifying: [<variant ids>] }.
   When a qualifying variant is in the cart we add the kit; when none remain we
   remove it. Make the kit $0 with an AUTOMATIC DISCOUNT in Shopify admin
   (the theme can add the line but cannot set its price to zero). */
(function () {
  function reconcile() {
    var cfg = window.ezcGiftKit;
    if (!cfg || !cfg.kitId || !cfg.qualifying || !cfg.qualifying.length || reconcile.busy) return;
    reconcile.busy = true;
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [], qualifies = false, kitLine = null;
        items.forEach(function (i) {
          if (cfg.qualifying.indexOf(i.variant_id) > -1 || cfg.qualifying.indexOf(i.id) > -1) qualifies = true;
          if (i.variant_id === cfg.kitId || i.id === cfg.kitId) kitLine = i;
        });
        if (qualifies && !kitLine) return apply('/cart/add.js', { id: cfg.kitId, quantity: 1 });
        if (!qualifies && kitLine) return apply('/cart/change.js', { id: cfg.kitId, quantity: 0 });
        reconcile.busy = false;
      })
      .catch(function () { reconcile.busy = false; });
  }
  function apply(url, body) {
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
      .then(function () { reconcile.busy = false; if (window.__ezcSyncDrawer) window.__ezcSyncDrawer(); })
      .catch(function () { reconcile.busy = false; });
  }
  document.addEventListener('ezc:cart:added', function () { setTimeout(reconcile, 100); });
  function start() {
    reconcile();
    var drawer = document.querySelector('cart-drawer');
    if (drawer) new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].attributeName === 'class' && drawer.classList.contains('active')) { setTimeout(reconcile, 250); break; }
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
